__turbopack_context__.v({
  "blueButton": "gqyUxa_blueButton",
  "centered": "gqyUxa_centered",
  "emptyTitle": "gqyUxa_emptyTitle",
  "root": "gqyUxa_root",
});
